import React, { useMemo, useState } from 'react';
import CustomSelect from './CustomSelect';
import Checkbox from './Checkbox';
import { useTranslation } from '../../hooks/useTranslation';



const getFollowersOptions = (t) => ([
  { value: 'lt3k', label: t('registration.final.followersRange.options.lt3k') },
  { value: '3kTo10k', label: t('registration.final.followersRange.options.3kTo10k') },
  { value: '10kTo30k', label: t('registration.final.followersRange.options.10kTo30k') },
  { value: '50kTo100k', label: t('registration.final.followersRange.options.50kTo100k') },
  { value: 'gt100k', label: t('registration.final.followersRange.options.gt100k') },
]);

const getHearAboutUsOptions = (t) => ([
  { value: 'socialMedia', label: t('registration.final.hearAboutUs.options.socialMedia') },
  { value: 'friend', label: t('registration.final.hearAboutUs.options.friend') },
  { value: 'advertisement', label: t('registration.final.hearAboutUs.options.advertisement') },
  { value: 'event', label: t('registration.final.hearAboutUs.options.event') },
  { value: 'other', label: t('registration.final.hearAboutUs.options.other') },
]);

export default function Step4({ formData, setFormData }) {
  const { t } = useTranslation();
  const followersOptions = useMemo(() => getFollowersOptions(t), [t]);
  const hearAboutUsOptions = useMemo(() => getHearAboutUsOptions(t), [t]);
  const [errors, setErrors] = useState({});

  const isValidUrl = (s) => {
    if (!s) return false;
    try {
      const u = new URL(s);
      return u.protocol === 'http:' || u.protocol === 'https:';
    } catch (_) {
      return false;
    }
  };

  const setField = (key) => (e) => {
    const val = e.target.value;
    setFormData((prev) => ({ ...prev, [key]: val }));
    if (key === 'referralDetails' && formData.referral === 'yes') setErrors((prev) => ({ ...prev, referralDetails: val.trim() ? '' : t('validation.required') }));
    if (['instagramProfile','tiktokProfile','youtubeProfile','snapchatProfile'].includes(key)) {
      const msg = val && !isValidUrl(val) ? t('validation.invalidUrl') : '';
      setErrors((prev) => ({ ...prev, [key]: msg }));
    }
  };
  const setSingleChoice = (key, val) => setFormData((prev) => ({ ...prev, [key]: prev[key] === val ? '' : val }));

  return (
    <div className="space-y-5">
      <p className='text-[20px]  my-5 font-[700] text-[#5D4A9D] text-start'>{t('registration.step4Title')}</p>

      {/* Social Profiles */}
      <div className="text-start">
        <label className="text-[18px]   font-[600] mb-2 block">{t('registration.final.socialProfiles.label')}</label>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          <div>
            <label className="block primary-text text-[14px] font-[500] mb-1">{t('registration.final.socialProfiles.instagram.label')}</label>
            <input
              type="url"
              placeholder={t('registration.final.socialProfiles.instagram.placeholder')}
              value={formData.instagramProfile || ''}
              onChange={setField('instagramProfile')}
              onBlur={() => setErrors((prev) => ({ ...prev, instagramProfile: (formData.instagramProfile && !isValidUrl(formData.instagramProfile)) ? t('validation.invalidUrl') : '' }))}
              className="w-full border-[1px] rounded-[8px] px-[18px] py-2 bg-[#F5F5F5] border-[#E6E6E6] h-[46px] placeholder:text-[16px] text-[16px] focus:bg-[#fff] focus:outline-none focus:ring-[1.5px] focus:ring-[#5D4A9D]"
            />
            {errors.instagramProfile ? <p className="text-red-500 text-[12px] mt-1 text-start ">{errors.instagramProfile}</p> : null}
          </div>
          <div>
            <label className="block primary-text text-[14px] font-[500] mb-1">{t('registration.final.socialProfiles.tiktok.label')}</label>
            <input
              type="url"
              placeholder={t('registration.final.socialProfiles.tiktok.placeholder')}
              value={formData.tiktokProfile || ''}
              onChange={setField('tiktokProfile')}
              onBlur={() => setErrors((prev) => ({ ...prev, tiktokProfile: (formData.tiktokProfile && !isValidUrl(formData.tiktokProfile)) ? t('validation.invalidUrl') : '' }))}
              className="w-full border-[1px] rounded-[8px] px-[18px] py-2 bg-[#F5F5F5] border-[#E6E6E6] h-[46px] placeholder:text-[16px] text-[16px] focus:bg-[#fff] focus:outline-none focus:ring-[1.5px] focus:ring-[#5D4A9D]"
            />
            {errors.tiktokProfile ? <p className="text-red-500 text-[12px] mt-1 text-start ">{errors.tiktokProfile}</p> : null}
          </div>
          <div>
            <label className="block primary-text text-[14px] font-[500] mb-1">{t('registration.final.socialProfiles.youtube.label')}</label>
            <input
              type="url"
              placeholder={t('registration.final.socialProfiles.youtube.placeholder')}
              value={formData.youtubeProfile || ''}
              onChange={setField('youtubeProfile')}
              onBlur={() => setErrors((prev) => ({ ...prev, youtubeProfile: (formData.youtubeProfile && !isValidUrl(formData.youtubeProfile)) ? t('validation.invalidUrl') : '' }))}
              className="w-full border-[1px] rounded-[8px] px-[18px] py-2 bg-[#F5F5F5] border-[#E6E6E6] h-[46px] placeholder:text-[16px] text-[16px] focus:bg-[#fff] focus:outline-none focus:ring-[1.5px] focus:ring-[#5D4A9D]"
            />
            {errors.youtubeProfile ? <p className="text-red-500 text-[12px] mt-1 text-start ">{errors.youtubeProfile}</p> : null}
          </div>
          <div>
            <label className="block primary-text text-[14px] font-[500] mb-1">{t('registration.final.socialProfiles.snapchat.label')}</label>
            <input
              type="url"
              placeholder={t('registration.final.socialProfiles.snapchat.placeholder')}
              value={formData.snapchatProfile || ''}
              onChange={setField('snapchatProfile')}
              onBlur={() => setErrors((prev) => ({ ...prev, snapchatProfile: (formData.snapchatProfile && !isValidUrl(formData.snapchatProfile)) ? t('validation.invalidUrl') : '' }))}
              className="w-full border-[1px] rounded-[8px] px-[18px] py-2 bg-[#F5F5F5] border-[#E6E6E6] h-[46px] placeholder:text-[16px] text-[16px] focus:bg-[#fff] focus:outline-none focus:ring-[1.5px] focus:ring-[#5D4A9D]"
            />
            {errors.snapchatProfile ? <p className="text-red-500 text-[12px] mt-1 text-start ">{errors.snapchatProfile}</p> : null}
          </div>
        </div>
      </div>

      <div className="mb-4 text-start">
        <label className="text-[14px]   font-[500] mb-2">{t('registration.final.followersRange.label')} <span></span></label>
        <CustomSelect
          options={followersOptions}
          value={formData.followersRange || ''}
          onChange={(v) => { setFormData((prev) => ({ ...prev, followersRange: v }));  }}
          // onBlur={() => setErrors((prev) => ({ ...prev, followersRange: formData.followersRange ? '' : t('validation.required') }))}
          placeholder={t('registration.final.followersRange.placeholder')}
        />
        {/* {errors.followersRange ? <p className="text-red-500 text-[12px] mt-1 text-start ">{errors.followersRange}</p> : null} */}
      </div>

      {/* How did you hear about us? */}
      <div className="text-start">
        <label className="text-[14px]   font-[500] mb-2">{t('registration.final.hearAboutUs.label')}</label>
        <CustomSelect
          options={hearAboutUsOptions}
          value={formData.hearAboutUs || ''}
          onChange={(v) => setFormData((prev) => ({ ...prev, hearAboutUs: v }))}
          placeholder={t('registration.final.hearAboutUs.placeholder')}
        />
      </div>

      {/* Referral */}
      <div className="text-start pt-2">
        <label className="text-[18px]   font-[600] mb-1 block">{t('registration.final.referral.label')}</label>
        <p className="text-[#495057] text-[14px]   mb-2">{t('registration.final.referral.question')}</p>
        <div className="space-y-2">
          {['yes', 'no'].map((v) => (
            <Checkbox
              key={v}
              label={t(`registration.final.referral.options.${v}`)}
              checked={(formData.referral || '') === v}
              onChange={() => setSingleChoice('referral', v)}
            />
          ))}
        </div>
        {formData.referral === 'yes' && <div className="mt-3">
          <label className="block primary-text text-[14px] font-[500] mb-1">
            {t('registration.final.referral.details.label')}  <span>*</span>
          </label>
          <input
            type="text"
            placeholder={t('registration.final.referral.details.placeholder')}
            value={formData.referralDetails || ''}
            onChange={setField('referralDetails')}
            onBlur={() => setErrors((prev) => ({ ...prev, referralDetails: (formData.referralDetails || '').trim() ? '' : t('validation.required') }))}
            className={`w-full border-[1px] rounded-[8px] px-[18px] py-2 bg-[#F5F5F5] border-[#E6E6E6] h-[46px] placeholder:text-[16px] text-[16px] focus:bg-[#fff] focus:outline-none focus:ring-[1.5px] focus:ring-[#5D4A9D] ${formData.referral === 'no' ? 'opacity-50' : ''}`}
            disabled={formData.referral === 'no'}
          />
          {errors.referralDetails ? <p className="text-red-500 text-[12px] mt-1 text-start ">{errors.referralDetails}</p> : null}
        </div>}
      </div>

      <div className="text-start pb-5">
        <label className="text-[18px]   font-[500] mb-2">{t('registration.final.agreement.label')} <span>*</span></label>
        <div className="mt-2 flex items-start">
          <Checkbox
            label={t('registration.final.agreement.text')}
            checked={Boolean(formData.agreementAccepted)}
            policy={true}
            className="flex !items-start"
            onChange={() => setFormData((prev) => ({ ...prev, agreementAccepted: !prev.agreementAccepted }))}
          >
            <div className=''>
              {t('registration.final.agreement.text')} {" "}
              <a target='_blank' href="/#/terms-and-conditions" className="text-[#5D4A9D] font-[600]  underline">Hoppy Station <span className='lowercase'> {t('footer.Terms')} </span></a>
            </div>
          </Checkbox>
        </div>
        {Boolean(!formData.agreementAccepted) ? <p className="text-red-500 text-[12px] mt-1 text-start ">{t('validation.required')}</p> : null}
      </div>
    </div>
  );
}